import {useEffect, useState} from "react";

// Components

// Scss
import '../assets/css/partnerPortal/welcome.scss';

import News from "../models/common/News";
import NewsRow from "./NewsRow";
import ButtonOne from "./ButtonOne";


function NewsSection(props) {


  const [newsList] = useState<Array<News>>(props.newsList);
  const buttonName = props.buttonName;
  const arrowWidth = props.arrowWidth;
  const action = props.action;



  function addNewsList() {
    return newsList
            .filter(n => n.alwaysShow || n.show)
            .map(n => <NewsRow info={n.info} link={n.link} putIcon={n.putIcon} title={n.title} buttonName={n.buttonName} arrowWidth={arrowWidth ? arrowWidth : null} />);
  }

  return (
    <>
      
        <div>
            {addNewsList()}
            {buttonName ? <ButtonOne text={buttonName + " "} link={"#"} action={action} /> : ""}
        </div>
            
    </>
  );


}

export default NewsSection;

